import { connect } from 'react-redux';

import {
  getOfficesShortList,
  getPublicZoneList,
} from '../../Offices/officesActions';
import { getOrganizationMembersList } from '../../Projects/projectsActions';
import {
  addDefaultSubTask,
  addTaskLocation,
  clearNewDefaultSubTask,
  createTask,
  getDefaultSubTasks,
  getMasterTasks,
  getTaskLocation,
  getTaskType,
} from '../tasksActions';
// Component
import CreateTask from './CreateTask';

// Store props to map with current state
const mapStateToProps = state => ({
  selectedOrganization: state.organization.selectedOrganization,
  orgMembersList: state.project.orgMembersList,
  officesShortList: state.office.officesShortList,
  publicZoneList: state.office.publicZoneList,
  memberShortListIsLoading: state.project.memberShortListIsLoading,
  isLoading: state.task.isLoading,
  addTaskLocationLoading: state.task.addTaskLocationLoading,
  createdTaskInfo: state.task.createdTaskInfo,
  locationsList: state.task.locationsList,
  createdTaskLocationInfo: state.task.createdTaskLocationInfo,
  taskTypeIsLoading: state.task.taskTypeIsLoading,
  taskTypeList: state.task.taskTypeList,
  defaultSubTasks: state.task.defaultSubTasks,
  isAddDefaultSubTaskLoading: state.task.isAddDefaultSubTaskLoading,
  newDefaultSubTask: state.task.newDefaultSubTask,
  masterTasksList: state.task.masterTasksList,
});

// Actions prop to dispatch
const mapDispatchToProps = dispatch => ({
  getOrganizationMembersList: params =>
    dispatch(getOrganizationMembersList(params)),
  createTask: params => dispatch(createTask(params)),
  getTaskLocation: params => dispatch(getTaskLocation(params)),
  addTaskLocation: params => dispatch(addTaskLocation(params)),
  getOfficesShortList: params => dispatch(getOfficesShortList(params)),
  getPublicZoneList: params => dispatch(getPublicZoneList(params)),
  getTaskType: params => dispatch(getTaskType(params)),
  getDefaultSubTasks: params => dispatch(getDefaultSubTasks(params)),
  clearNewDefaultSubTask: params => dispatch(clearNewDefaultSubTask(params)),
  addDefaultSubTask: params => dispatch(addDefaultSubTask(params)),
  getMasterTasks: params => dispatch(getMasterTasks(params)),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(CreateTask);
